module.exports = __webpack_public_path__ + "static/media/YGY_Products@3x.c98f27d1.png";